<template>
  <BaseField :element="element" :model="internalModel">
    <template v-slot:default="{ errors }">
      <v-checkbox
        v-model="internalModel"
        :label="fieldLabel"
        :name="field.id"
        :disabled="field.disabled"
        :readonly="field.readonly"
        :required="field.required"
        :error="errors.length > 0"
        :error-messages="errors"
      ></v-checkbox>
    </template>
  </BaseField>
</template>

<script>
import BaseField from "@/components/form/fields/BaseField";
import Component from "vue-class-component";

@Component({
  watch: {
    internalModel: function(newVal) {
      if (typeof this.field?.onChange === "function") {
        this.field.onChange(newVal);
      }
    }
  }
})
export default class CheckboxField extends BaseField { }
</script>